module.exports = __webpack_public_path__ + "static/media/mesothreads.d877c086.svg";